import { useState } from 'react';

import { DomuiError, DynamicData } from '@domui-domain/type';
import { useAppConfig } from '@domui-hooks/appConfig';
import Individual from '@domui-utils/workflow/individual';

// Custom hook to handle API calls
export const useSetPreferredLanguage = () => {
  const [data, setData] = useState<DynamicData>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<DomuiError>(null);
  const { user } = useAppConfig();

  const setPreferredLanguage = async (
    individualId: string,
    updateData: DynamicData
  ) => {
    try {
      if (updateData) {
        setLoading(true);
        setError(null); // Clear error before new request
        const wfService = new Individual();
        const response = await wfService.setPreferredLanguage(
          individualId,
          updateData
        );
        sessionStorage.removeItem(
          `cached-data-domino-user-account-${
            user?.isLoggedIn && user?.individualId ? user.individualId : null
          }`
        );
        setData(response);
        setLoading(false);
      }
    } catch (err) {
      setError(err as DomuiError);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, setPreferredLanguage };
};
